import React, { useState, useEffect, useRef, Fragment } from 'react';
import { useSelector } from 'react-redux';
import AnalyticsManager from '../../app/analytics';
import Validate from 'app/validation/validation';
import './contact_us.scss';
import {convertToSortedArray, executeWithCaptcha, getMediaPath} from "../../app/functions";
import { useSendNewContactMutation, useGetContactUsPageQuery } from 'redux/api/relations.api';
//components
import AnimatedInput from "../../components/forms/animated_input";
import AnimatedTextArea from "../../components/forms/animated_textarea";
import Select from "../../components/forms/select";
import {NavLink} from 'react-router-dom';
import * as routes from '../../constants/routes';
import DynamicLink from '../../components/dynamic_link/index';
import BreadCrumbs from '../../components/common/bread_crumbs';

//assets
import top_banner_mobile from 'assets/images/contact_us_header-bg-mobile.jpg';
import top_banner_desktop from 'assets/mock/contact_us_desktop_header.png';
import logo from 'assets/logos/logo.svg';
import Recaptcha from "../../components/services/google/recaptcha";
import ImageHeader from "../../components/image-header";


const ContactUs = () => {
    const deviceState = useSelector(store => store.state.deviceState);
    const text = useSelector(store => store.config.Translations);
    const requesting = useSelector(store => store.state.requesting);
    const userData = useSelector(store => store.config.UserData);

    const [submitMessage, setSubmitMessage] = useState('');
    
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);

    const [state, setState] = useState({
        first_try: true,
        form: {
            full_name: {
                val: '',
                valid: false,
                rules: ['not_empty', 'full_name'],
                errMsg: ''
            },
            id: {
                val: '',
                valid: false,
                rules: ['id'],
                errMsg: ''
            },
            email: {
                val: '',
                valid: false,
                rules: ['not_empty', 'email'],
                errMsg: ''
            },
            phone: {
                val: '',
                valid: false,
                rules: ['not_empty', 'phone'],
                errMsg: ''
            },
            message: {
                val: '',
                valid: false,
                rules: ['not_empty'],
                errMsg: ''
            }
        },
        subject: {
            errMsg: '',
            selected: -1,
            valid: false,
        },
        sub_subject: {
            errMsg: '',
            selected: -1,
            valid: false,
        },
    });


    const { data: contactPage, error, isLoading } = useGetContactUsPageQuery();

    const [submitContactUs, { isLoading: isSubmitting, error: submitError }] = useSendNewContactMutation();

    useEffect(() => {
        if (userData) {
            let fullName = userData.first_name ? `${userData.first_name + ' ' + userData.last_name}` : '';
            let id = userData['user_id'] ? userData['user_id'] : '';
            let email = userData['email'] ? userData['email'] : '';
            let phone = userData['phone'] ? userData['phone'] : '';

            let new_state = {
                ...state.form,
                ['full_name']: {
                    ...state.form['full_name'],
                    val: fullName, ...state.form['valid'], ...state.form['errMsg']
                },
                ['id']: {
                    ...state.form['id'],
                    val: id, ...state.form['valid'], ...state.form['errMsg']
                },
                ['email']: {
                    ...state.form['email'],
                    val: email, ...state.form['valid'], ...state.form['errMsg']
                },
                ['phone']: {
                    ...state.form['phone'],
                    val: phone, ...state.form['valid'], ...state.form['errMsg']
                }
            };
            setState(prevState => ({...prevState, form: new_state}));
        }
    }, [contactPage, userData]);

    useEffect(() => {
        if (isFormSubmitted && submitMessage) {
            AnalyticsManager.logContactUsMessageSent();
        }
    }, [isFormSubmitted, submitMessage]);

    const handleInputChange = (event) => {
        const { value: val, name } = event.target;
        let validate = Validate(val, state.form[name].rules);
        let is_valid = validate.valid;
        let msg = validate.msg;
        let new_state = {
            ...state.form,
            [name]: {...state.form[name], val: val, valid: is_valid, errMsg: msg}
        };
        setState(prevState => ({...prevState, form: new_state}));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let form_valid = true;
        let new_state = state.form;

        for (let field in state.form) {
            let validate = Validate(state.form[field].val, state.form[field].rules);
            let is_valid = validate.valid;
            let msg = validate.msg;

            new_state[field].valid = is_valid;
            new_state[field].errMsg = msg;

            if (is_valid === false) {
                form_valid = false;
            }
        }

        const subject = state.subject.selected !== -1;

        if (!subject) {
            setState(prevState => ({...prevState, subject: {...state.subject, errMsg: 'אנא בחרו נושא'}}));
        }

        const isSubSubjectSelected = state.sub_subject.selected !== -1;
        if (!isSubSubjectSelected) {
            setState(prevState => ({...prevState, sub_subject: {...state.sub_subject, errMsg: 'אנא בחרו נושא משני'}}));
        }

        setState(prevState => ({...prevState, form: new_state, first_try: false}));

        if (form_valid && subject) {
            executeWithCaptcha(async (token) => {
                let payload = {};
                for (let key in state.form) {
                    payload[key] = state.form[key].val
                }
                setState(prevState => ({...prevState, disable: true}));
                payload['subject'] = state.subject.selected;
                payload['sub_subject'] = state.sub_subject?.selected;
                payload['g-recaptcha-response'] = token;

                const response = await submitContactUs(payload);

                const message = response.data.message;

                setSubmitMessage(message);
                setIsFormSubmitted(true);
            })
        }
    }

    const getContactDetails = () => {
        const data = contactPage.icons;

        let res = [];

        data.forEach((item, index) => {
            res.push(
                <DynamicLink data={item.link} key={index} className='action-btn'>
                    <img className='action-icon' src={getMediaPath(item.imagePath)} alt='/'/>
                    <h3 className='action-title'>{item.title}</h3>
                    <span className='action-data'>{item.text}</span>
                </DynamicLink>
            )
        });

        return res;
    }

    const getAllSubjects = () => {
        const data = convertToSortedArray(contactPage.topics);
        let res = [];

        for (let key in data) {
            res.push({text: data[key].title, id: data[key].id});
        }

        return res;
    }

    const subjectOnChange = (id) => {
        setState(prevState => ({
            ...prevState,
            subject: {...state.subject, selected: id, errMsg: '', valid: true},
            sub_subject: {...state.sub_subject, selected: -1}
        }));
    }

    const sub_SubjectOnChange = (id) => {
        setState(prevState => ({...prevState, sub_subject: {...state.sub_subject, selected: id, errMsg: '', valid: true}}));
    }

    const getSubSubjectOptions = () => {
        const data = contactPage.topics[String(state.subject.selected)].sub_topics;

        let res = [];

        for (let key in data) {
            res.push({text: data[key].title, id: key});
        }

        return res;
    }

    const isMobile = deviceState === 'mobile';

    const showErrorName = !state.first_try && !state.form.full_name.valid;
    const showErrorId = !state.first_try && !state.form.id.valid;
    const showErrorEmail = !state.first_try && !state.form.email.valid;
    const showErrorPhone = !state.first_try && !state.form.phone.valid;
    const showErrorMassage = !state.first_try && !state.form.message.valid;
    const showErrorSubject = !state.first_try && !state.subject.valid;
    const showErrorSecondarySubject = !state.first_try && !state.sub_subject.valid;

    const mobileBanner = contactPage?.details?.main?.mobileBanner || top_banner_mobile
    const desktopBanner = contactPage?.details?.main?.banner || top_banner_desktop

    return (
        <section className='contact-us'>
            {contactPage &&
            <Fragment>
                <ImageHeader
                    title={contactPage.details.main.header.content}
                    subtitle={contactPage.details.main.sub_header.content}
                    image={getMediaPath(isMobile ? mobileBanner : desktopBanner)}
                />

                <BreadCrumbs root={{text: 'דף הבית', route: routes.home}} className="bread-crumbs" />

                <div className='secondary-banner'>
                    <h3 className='title'>{contactPage.details.form.header.content}</h3>
                    <p className='para'>{contactPage.details.form.sub_header.content}</p>
                </div>

                <form className='contact-form' onSubmit={handleSubmit}>
                    <div className='first-row'>
                        <AnimatedInput className={'field name'}
                                       value={state.form.full_name.val}
                                       name={'full_name'}
                                       placeholder={text.web_full_name_placeholder}
                                       onChange={handleInputChange}
                                       showError={showErrorName}
                                       errorMessage={state.form.full_name.errMsg}
                        />
                        <AnimatedInput className={'field'}
                                       value={state.form.id.val}
                                       name={'id'}
                                       placeholder={text.web_id_placeholder}
                                       onChange={handleInputChange}
                                       showError={showErrorId}
                                       errorMessage={state.form.id.errMsg}
                        />
                        <AnimatedInput className={'field email'}
                                       value={state.form.email.val}
                                       name={'email'}
                                       placeholder={text.web_burger_contact_placeholder}
                                       onChange={handleInputChange}
                                       showError={showErrorEmail}
                                       errorMessage={state.form.email.errMsg}
                        />
                        <AnimatedInput className={'field phone'}
                                       value={state.form.phone.val}
                                       name={'phone'}
                                       placeholder={text.web_phone_placeholder}
                                       onChange={handleInputChange}
                                       showError={showErrorPhone}
                                       errorMessage={state.form.phone.errMsg}
                        />
                    </div>

                    <div className={'select_input ' + (showErrorSubject ? 'error' : '')}>
                        <Select placeholder={text.web_subject_placeholder}
                                options={getAllSubjects()}
                                deviceState={'desktop'}
                                onChange={subjectOnChange}
                        />
                        <span className='error_msg'>{state.subject.errMsg}</span>
                    </div>

                    {state.subject?.selected !== -1 &&
                        <div className={'select_input ' + (showErrorSecondarySubject ? 'error' : '')}>
                            <Select placeholder={text.web_sub_subject_placeholder}
                                    options={getSubSubjectOptions()}
                                    deviceState={'desktop'}
                                    onChange={sub_SubjectOnChange}
                            />
                            <span className='error_msg'>{state.sub_subject.errMsg}</span>
                        </div>
                    }

                    <AnimatedTextArea className={'field'}
                                      value={state.form.message.val}
                                      name={'message'}
                                      placeholder={text.web_your_message_placeholder}
                                      onChange={handleInputChange}
                                      showError={showErrorMassage}
                                      errorMessage={state.form.message.errMsg}
                    />

                    <input type='submit' name="submit" className={'submit-btn ' + (requesting ? 'disabled' : '')}
                           value={text.web_send_label}/>
                    <Recaptcha isFunction={false} enterprise={true}/>
                </form>

                <div className='contact-details-container'>
                    {getContactDetails()}
                </div>
                {isFormSubmitted &&
                <div className='success-layout'>
                    <img className='logo' src={getMediaPath(logo)} alt='/'/>
                    <h1 className='message'>{submitMessage}</h1>
                    <NavLink to={routes.home} className='back-link'>{text.web_return_to_home}</NavLink>
                </div>
                }
            </Fragment>
            }
        </section>
    )
}

export default ContactUs;
